import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  link?: string;
}

interface NavigationPage { 
  title: string; 
  link: string; 
}

@Component({
  selector: 'app-assurance-transport',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-transport.component.html',
  styleUrls: ['./assurance-transport.component.scss']
})
export class AssuranceTransportComponent {
  title = 'Assurance Transport';
  subtitle = 'Protection complète pour vos activités de transport';
  heroImage = 'assets/static_pages_images/Transport.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Transport', link: undefined }
  ];

  prevPage: NavigationPage = { 
    title: 'Assurance Marchandises Transportées', 
    link: '/assurance-marchandises-transportees'
  };

  nextPage: NavigationPage = { 
    title: 'Assurance Loueur de Véhicules', 
    link: '/assurance-loueur-vehicules'
  };
}
